import { createPopper } from '@popperjs/core';

const PefcContactSidebar = (el: Element) => {
    const button = el.querySelectorAll('[role="button"]')[0];
    const tooltip = el.querySelectorAll('[role="tooltip"]')[0];
    const popperInstance = createPopper(button, tooltip as HTMLElement, {
        placement: 'bottom'
    });
    let isOpen = false;
    const modifiers = [
        { name: 'eventListeners', enabled: true },
        {
            name: 'offset',
            options: {
                offset: [-40, 20]
            }
        }
    ];
    const toggle = () => {
        tooltip.classList.toggle('box__tooltip--open');
        // Enable the event listeners
        popperInstance.setOptions((options) => ({
            ...options,
            modifiers
        }));

        popperInstance.update();
        isOpen = !isOpen
    };



    button.addEventListener('click', toggle);
    let isTouch = false;
    const canClose = (e: any) => {
        return el && e.target && tooltip.contains(e.target as Node);
    };

    const clickoutside = (e: Event) => {
        if (e.type === 'touchend') {
            isTouch = true;
        }
        if (e.type === 'click' && isTouch) {
            return;
        }

        if (canClose(e)) {
            tooltip.classList.remove('box__tooltip--open');
            isOpen = false
        } else {
            // if (isOpen) {
            //     e.stopPropagation();
            // }
        }
    };
    document.addEventListener('touchend', clickoutside, true);
    document.addEventListener('click', clickoutside, true);
};

export default PefcContactSidebar;
